// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2L717","buttons":"styles_buttons__3SNST"};